import React, { memo, useMemo } from 'react';
import { EDGE_COLOR } from '../edgeColors';

export const TreeEdge = memo(({ 
  id, 
  source, 
  target, 
  sourceX, 
  sourceY, 
  targetX, 
  targetY, 
  style
}) => {
  const computedStyle = useMemo(() => {
    return {
      strokeWidth: 2,
      opacity: 0.6,
      ...style,
      stroke: style?.stroke ?? EDGE_COLOR
    };
  }, [style]);

  const path = `M ${sourceX},${sourceY} C ${sourceX},${(sourceY + targetY) / 2} ${targetX},${(sourceY + targetY) / 2} ${targetX},${targetY}`;
  
  return (
    <path
      id={id}
      style={computedStyle}
      className="react-flow__edge-path"
      d={path}
    />
  );
});

export default TreeEdge;